import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Link, useNavigate } from "react-router-dom";
import { Delete, FileGetData, getData } from '../API';
import * as XLSX from 'xlsx';
import { parseISO, format, parse } from 'date-fns';
import { Button, Modal } from "react-bootstrap";
import ReportEdit from "./ReportEdit";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import ReportAdd from "./ReportAdd";

function Reports() {
  const formattedDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'MMMM d, yyyy');
  };
  const [filteredData, setFilteredData] = useState([]);
  const [establishData, setEstablishData] = useState([]);
  const [ownerTypeData, setOwnerTypeData] = useState([]);
  const [allSurveyorsData, setAllSurveyorsData] = useState([]);
  const [allWardData, setAllWardData] = useState([]);
  const [allZoneData, setAllZoneData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editShow, setEditShow] = useState(false);
  const [addShow,setAddShow] = useState(false);
  const [addDetails,setAddDetails] = useState(false);
  const [search, setSearch] = useState("");
  const [editdetails, setEditdetails] = useState({});
  const fileInputRef = useRef(null);
  const gridRef = useRef();
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("canWrite");
  const handleEditClose = () => {
    setEditShow(false);
  };
  const handleAddClose = () => {
    setAddShow(false);
  }
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem('filters');
    if (savedFilters) {
      return JSON.parse(savedFilters);
    }
    return {
      establishmentTypeId: '',
      ownerTypeId: '',
      userId: '',
      fromDate: getInitialFromDate(),
      toDate: getCurrentDate(),
      zoneId: '',
      wardNo: '',
      isUpdated: '',
    };
  };

  const BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [filters, setFilters] = useState(getInitialFilters());
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchData(filters);
    getAllData();
    getAllOwnerType();
    getAllSurveyorType();
    getZoneType();
    handleBulkUpload();
  }, []);
  useEffect(() => {
    if (filters.zoneId) {
      getWardType(filters.zoneId);
    } else {
      setAllWardData([]);
    }
  }, [filters.zoneId]);

  useEffect(() => {
    const handleResize = () => {
      gridRef.current.api.sizeColumnsToFit();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('filters');
      const initialFilters = {
        establishmentTypeId: '',
        ownerTypeId: '',
        userId: '',
        fromDate: getInitialFromDate(),
        toDate: getCurrentDate(),
        zoneId: '',
        wardNo: ''
      };
      setFilters(initialFilters);
      fetchData(initialFilters);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('filters', JSON.stringify(filters));
  }, [filters]);

  const buildQueryParams = (filters) => {
    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });
    return queryParams.toString();
  };

const fetchData = async (filters) => {
  setIsLoading(true); // Start loading

  try {
    const { fromDate, toDate } = filters;
    const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
    const formattedToDate = new Date(toDate).toISOString().split('T')[0];
    const updatedFilters = { ...filters, fromDate: formattedFromDate, toDate: formattedToDate };

    const queryParams = buildQueryParams(updatedFilters);
    const data = await getData(`SurveyDetails/v2/FilteredSurveys?${queryParams}`);

    setFilteredData(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error('Error fetching data:', error);
    setFilteredData([]);
  } finally {
    setIsLoading(false); // Done loading
  }
};
  const getAllData = async () => {
    try {
      const res = await getData('SurveyMasters/EstablishmentTypes');
      // const response = await res.json();
      setEstablishData(res.data);
    } catch (error) {
      console.error('Error fetching establishment data:', error);
      setEstablishData([]);
    }
  };

  const getAllOwnerType = async () => {
    try {
      const res = await getData('SurveyMasters/OwnershipTypes');
      // const response = await res.json();
      setOwnerTypeData(res.data);
    } catch (error) {
      console.error('Error fetching owner type data:', error);
      setOwnerTypeData([]);
    }
  };

  const getAllSurveyorType = async () => {
    try {
      const res = await getData('SurveyDetails/GetAllSureveyors');
      // const data = await res.json();
      if (Array.isArray(res)) {
        setAllSurveyorsData(res);
      } else {
        setAllSurveyorsData([]);
      }
    } catch (error) {
      console.error('Error fetching surveyors:', error);
      setAllSurveyorsData([]);
    }
  };

  const getWardType = async (zoneId) => {
    try {
      const res = await getData(`SurveyMasters/GetAllWards?zoneId=${zoneId}`);
      // const response = await res.json();
      setAllWardData(res.data);
    } catch (error) {
      console.error('Error fetching ward data:', error);
      setAllWardData([]);
    }
  };

  const getZoneType = async () => {
    try {
      const res = await getData('SurveyMasters/UCCZoneMasters');
      // const response = await res.json();
      setAllZoneData(res.data);
    } catch (error) {
      console.error('Error fetching zone data:', error);
      setAllZoneData([]);
    }
  };

  function getInitialFromDate() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    return sevenDaysAgo.toISOString().split('T')[0];
  }

  function getCurrentDate() {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const filterData = (data, filters) => {
    return data.filter((item) => {
      if (filters.isUpdated !== "") {
        const isVerified = filters.isUpdated === "true";
        // Show only items matching the filter or null for "unverified"
        return item.isUpdated === isVerified || (item.isUpdated === null && !isVerified);
      }
      return true; // Include all if no filter is applied
    });
  };


  const handleZoneChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      zoneId: value,
      wardNo: ''
    }));
  };

  const handleSearch = () => {
    fetchData(filters);
  };

  const handleDelete=async(data)=>
  {
    const url=`SurveyDetails/DeleteFilteredSurveys/${data.sdid}`
   
   try{
    const res=await Delete(url);
    fetchData(filters);
    toast.success(res)
   }catch(error){
     toast.error("error",error)
   }

  }

  const downloadExcel = () => {
    const tableHeaders = ["S.No", "Surveyor Id", "Surveyor Name", "Owner Name", "Surveyor Date", "Owner Contact No", "Property House No.", "Address",
      "Establishment Type", "OwnerShip Type", "Muncipal RegNo", "Registration StartDate", "Registration EndDate", "House No", "Email Id", "MinWaste Qty",
      "Commercial Type", "Rate Type", "Display Rate", "Tenant Name", "Tenant ContactNo", "No Of Members", "Landmark", "Remarks",
      "Zone", "Ward", "Rate Category Name", "Rate Sub Category Name", "Extra Area", "Municipal CommercialNo", "Fixed Value","Service Status", "Verified"
    ];
    const tableData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Surveyor Id": item.userId,
      "Surveyor Name": item.userName,
      "Owner Name": item.ownerName,
      "Surveyor Date": new Date(item.createdDate).toLocaleDateString(),
      "Owner Contact No": item.ownerContactNo,
      "Property House No.": item.houseNo,
      "Address": item.address,
      "Establishment Type": item.establishmentType,
      "OwnerShip Type": item.ownerShipType,
      "Muncipal RegNo": item.muncipalRegNo,
      "Registration StartDate": item.registrationStartDate && formattedDate(item.registrationStartDate),
      "Registration EndDate": item.registrationEndDate && formattedDate(item.registrationEndDate),
      "House No": item.houseNo,
      "Email Id": item.emailId,
      "minWasteQty": item.minWasteQty,
      "Commercial Type": item.commercialType,
      "Rate Type": item.rateType,
      "Display Rate": item.displayRate,
      "Tenant Name": item.tenantName,
      "Tenant ContactNo": item.tenantContactNo,
      "No Of Members": item.noOfMembers,
      "Landmark": item.landmark,
      "Remarks": item.remarks,
      "Zone": item.zoneName,
      "Ward": item.wardNo,
      "Rate Category Name": item.rateCategoryName,
      "Rate Sub Category Name": item.rateSubCategoryName,
      "Extra Area": item.extraArea,
      "Municipal CommercialNo": item.municipalCommercialNo,
      "Fixed Value": item.fixedValue,
      "Service Status":item.serviceStatusName,
      "Verified": item.isUpdated === true ? "Verified" : "Unverified",
    }));
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A1' });
    worksheet['!cols'] = [
      { wpx: 30 },  // Width for S.No
      { wpx: 60 }, //width for Surveyor ID
      { wpx: 100 },
      { wpx: 150 }, // Width for Owner Name
      { wpx: 100 }, // Width for Surveyor Date
      { wpx: 100 }, // Width for Owner Contact No
      { wpx: 120 }, // Width for Property House No.
      { wpx: 200 }, // Width for Address
      { wpx: 150 },
      { wpx: 150 }, // Width for establishmentType
      { wpx: 150 }, // Width for ownerShipType
      { wpx: 120 }, // Width for muncipalRegNo
      { wpx: 120 }, // Width for registrationStartDate
      { wpx: 100 }, // Width for registrationEndDate
      { wpx: 200 }, // Width for houseNo
      { wpx: 100 }, // Width for emailId
      { wpx: 150 }, // Width for minWasteQty
      { wpx: 100 }, // Width for commercialType
      { wpx: 70 }, // Width for rateType
      { wpx: 150 }, // Width for displayRate
      { wpx: 120 }, // Width for tenantName
      { wpx: 150 }, // Width for tenantContactNo
      { wpx: 100 }, // Width for noOfMembers
      { wpx: 150 }, // Width for landmark
      { wpx: 100 }, // Width for remarks
      { wpx: 100 }, // Width for zoneName
      { wpx: 150 }, // Width for wardNo
      { wpx: 200 }, // Width for rateCategoryName
      { wpx: 120 }, // Width for rateSubCategoryName
      { wpx: 150 }, // Width for extraArea
      { wpx: 120 }, // Width for municipalCommercialNo
      { wpx: 100 }, // Width for fixedValue
      { wpx: 100 }  // Width for verified
    ];
    // const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports Data");
    XLSX.writeFile(workbook, "ReportsData.xlsx");
  };

  const columnDefs = [
    {
      headerName: "S.No",
      field: "sNo",
      maxWidth: "100",
      valueGetter: (params) => params.node.rowIndex + 1,
      headerClass: "grid-header",
    },
    {
      field: "establishmentType",
      headerName: "Type of Establishment",
      headerClass: "grid-header",
    },
    {
      field: "ownerName",
      headerName: "Owner Name",
      headerClass: "grid-header",
    },
    {
      field: "ownerContactNo",
      headerName: "Owner Contact No",
      headerClass: "grid-header",
    },
    {
      headerName: 'Surveyor Date',
      field: 'createdDate',
      valueFormatter: params => new Date(params.value).toLocaleDateString(),
      headerClass: "grid-header",
    },
    {
      field: "houseNo",
      headerName: "Property House No.",
      headerClass: "grid-header",
    },
    {
      field: "address",
      headerName: "Address",
      headerClass: "grid-header",
    },
    {
      field: "serviceStatusName",
      headerName: "Service Status",
      headerClass: "grid-header",
    },
    // {
    //   field: "isUpdated",
    //   headerName: "Verified",
    //   cellRenderer: (params) => {
    //     if (params.value === null || params.value === false) {
    //       return "Unverified";
    //     }
    //     return "Verified";
    //   },
    // },
    {
      field: "status",
      headerName: "Verified",
      headerClass: "grid-header",
      cellRenderer: (params) => {
        const status = params.value;
    
        let statusLabel;
        let statusClass;
    
        switch (status) {
          case 0:
            statusLabel = "Unverified";
            statusClass = "text-danger";
            break;
          case 1:
            statusLabel = "Verified";
            statusClass = "text-success";
            break;
          case 2:
            statusLabel = "Waiting for Approval";
            statusClass = "text-warning";
            break;
          default:
            statusLabel = "Unknown";
            statusClass = "text-muted";
        }
    
        return (
          <div className="d-flex justify-content-around">
            <span className={statusClass}>{statusLabel}</span>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width:100,
      cellRenderer: (params) => {
        const primaryId = params.data.sdid;
        const secondaryId = params.data.parentGuid;
        const url = (secondaryId !== null && secondaryId !== undefined) ? `/reports-view/${primaryId}/${secondaryId}` : `/reports-view/${primaryId}`;
        const editUrl = `/edit/${primaryId}`;
        return (
          <div className="d-flex justify-content-around gap-2 mt-2">
            {isAdmin === "True" && <button
              onClick={() => {
                setEditdetails(params.data)
                setEditShow(true);
              }}
              className="btn btn-sm rounded-3"
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                color: "white",
                background: "#9CA3AF",
                fontWeight: 600,
              }}
            >
              Edit
            </button>}
            <button
              className="btn btn-sm rounded-3 "
              style={{
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
                background: "#9CA3AF",
                fontWeight: 600,
               
              }}
            >
              <Link to={url} className="text-white">
                View
              </Link>
            </button>
            <button
              className="btn btn-sm rounded-3 "
              style={{
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
                background: "red",
                fontWeight: 600,
                color:"white"
               
              }}
              onClick={()=>handleDelete(params.data)}
            >
              
                Delete
             
            </button>
          </div>
        );
      },
      headerClass: "grid-header",
      cellClass: "no-right-border",
      suppressMenu: true,
      sortable: false
    }
  ];
  // const defaultColDef = {
  //   sortable: true,
  //   resizable: true,
  //   flex: 1,

  // };

  const defaultColDef = {
    flex: 1,
    resizable: true,
    minWidth: 180,
    sortable: true,
    suppressSizeToFit: true,
  };
const handleBulkDownload = async (filters) => {
  

  try {
    // Format filters
    const { fromDate, toDate } = filters;
    const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
    const formattedToDate = new Date(toDate).toISOString().split('T')[0];
    const updatedFilters = {
      ...filters,
       // include zoneId in filters
      fromDate: formattedFromDate,
      toDate: formattedToDate,
    };

    // Build query params
    const queryParams = buildQueryParams(updatedFilters);

    // Call API with query params
    const response = await FileGetData(`SurveyDetails/DownloadBulkDetails?${queryParams}`);

    if (!response.ok) {
      throw new Error("Failed to download file from backend");
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `BulkDownloadData.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Error during bulk download:", error);
  }
};

  const handleBulkUpload = async (event) => {
    if (!event || !event.target) {
      console.error("Event or event target is undefined");
      return;
    }
    const file = event.target.files[0];
    console.log("Selected file:", file);
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
      const token = localStorage.getItem('token');
      try {
        setIsLoading(true);
        // console.log("Sending request to API...");
        const res = await fetch(BASE_URL + `SurveyDetails/UpdateBulkDetails`, {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData,
        });
        if (res.status === 409) {
          const errorResponse = await res.json();
          // console.log("409 Error:", errorResponse.message);
          toast.error(errorResponse.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        if (res.status === 200) {
          const result = await res.json();
          // console.log("File uploaded successfully", result);
          toast.success("File uploaded successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else if (res.status === 400) {
          toast.error("No valid records found in the uploaded CSV file.", {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          const errorResponse = await res.text();
          console.error("File upload failed:", errorResponse);
          toast.error("File upload failed: " + errorResponse, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } catch (error) {
        toast.error("An error occurred while uploading the file", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error("Please select a file to upload", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
     <div>
     <ToastContainer />
      <main className="page-content content">
        <div className="container-fluid p-0">
          <div className="row align-items-center mb-3">
            <div className="col-md-12">
              <h1 className="title_pages">UnVerified Reports</h1>
            </div>
          </div>
          <div className='filters'>
            <div className='row align-items-end'>
              <div className="col-md-12">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Type of Establishment</label>
                      <select type="select" className='form-select' name="establishmentTypeId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.establishmentTypeId}>
                        <option value="">Select</option>
                        {establishData.map((establishment) => (
                          <option key={establishment.establishmentTypeId} value={establishment.establishmentTypeId}>{establishment.establishmentTypeName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Type of Owner</label>
                      <select type="select" className='form-select' name="ownerTypeId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.ownerTypeId}>
                        <option value="">Select</option>
                        {ownerTypeData.map((ownerType) => (
                          <option key={ownerType.ownershipTypeId} value={ownerType.ownershipTypeId}>{ownerType.ownershipTypeName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Surveyor name</label>
                      <select type="select" className='form-select' name="userId" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.userId}>
                        <option value="">Select</option>
                        {allSurveyorsData.length > 0 ? (
                          allSurveyorsData.map((surveyor) => (
                            surveyor.displayName != null && <option key={surveyor.userId} value={surveyor.userId}>{surveyor.displayName}</option>
                          ))
                        ) : (
                          <option value="">No surveyors found</option>
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Zone</label>
                      <select type="select" className='form-select' name="zoneId" onChange={handleZoneChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.zoneId}>
                        <option value="">Select</option>
                        {allZoneData.map((zone) => (
                          <option key={zone.uccZoneId} value={zone.uccZoneId}>{zone.zoneName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>Ward</label>
                      <select type="select" className='form-select' name="wardNo" onChange={handleFilterChange} style={{ backgroundColor: "#D9D9D9", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }} value={filters.wardNo}>
                        <option value="">Select</option>
                        {allWardData.map((ward) => (
                          <option key={ward.wardId} value={ward.wardNo}>{`${ward.wardNo} - ${ward.wardName}`}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>From Date</label>
                      <input
                        style={{ boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }}
                        type="date"
                        className='form-control'
                        name="fromDate"
                        value={filters.fromDate}
                        onChange={handleFilterChange}
                        max={new Date().toISOString().split('T')[0]}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className='form-group'>
                      <label>To Date</label>
                      <input style={{ boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }}
                        type="date"
                        className='form-control'
                        name="toDate"
                        value={filters.toDate}
                        onChange={handleFilterChange}
                        max={new Date().toISOString().split('T')[0]}

                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Verified</label>
                      <select
                        className="form-select"
                        name="isUpdated"
                        onChange={handleFilterChange}
                        style={{
                          backgroundColor: "#D9D9D9",
                          boxShadow:
                            "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                        }}
                        value={filters.isUpdated}
                      >
                        <option value="">Select</option>
                        <option value="true">Verified</option>
                        <option value="false">Unverified</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2 mb-3">
                      <label for="search-input" class="form-label">
                        Search
                      </label>
                      <div class="position-relative">
                        <input
                          type="search"
                          id="search-input"
                          class="search-button px-3"
                          placeholder="Search..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>
                    </div>
                  <div className="col-md-3 mb-3 text-start d-flex gap-2">
                    <button
                      className="btn px-4"
                      onClick={handleSearch}
                      style={{
                        background: "#a7252ced",
                        border: "none",
                        color: "white",
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      SEARCH
                    </button>
                    <button
                      className="btn px-4"
                      onClick={() => {
                        localStorage.removeItem("filters");
                        const initialFilters = {
                          establishmentTypeId: "",
                          ownerTypeId: "",
                          userId: "",
                          fromDate: getInitialFromDate(),
                          toDate: getCurrentDate(),
                          zoneId: "",
                          wardNo: "",
                          isUpdated: "", // Ensure this field is reset
                        };
                        setFilters(initialFilters); // Update the state
                        fetchData(initialFilters); // Fetch data with initial filters
                      }}
                      style={{
                        background: "#a7252ced",
                        border: "none",
                        color: "white",
                        boxShadow:
                          "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                      }}
                    >
                      Reset
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
            {/* Left side: Excel button */}
            <div className='text-start'>
              <button className='btn' onClick={downloadExcel} style={{ background: "#9CA3AF", color: "white", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',marginRight:"5px" }}>
                Excel <i className="fa-solid fa-download ms-1"></i>
              </button>
              <button
              className="btn"
              style={{
                background: "#9CA3AF",
                color: "white",
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                
              }}
              onClick={() => navigate("/unverified-deleted-report")}
            >
            Deleted UnVerified Records <i class="fa-solid fa-trash"></i>
            </button>
            </div>

            {/* Right side: Bulk Download and Upload buttons */}
            <div className="d-flex">
              <button
               className="btn me-2"
               onClick={() => {
                navigate(`/unverified-report-add-form`, {
                });
              }}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
              Add <i className="fa-solid fa-plus ms-1"></i>
              </button>
              <button
                className="btn me-2"
                onClick={(params) => {
                  setAddDetails(params.data)
                  setAddShow(true);
                }}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
              >
                Add Bulk Upload<i className="fa-solid fa-plus ms-1"></i>
              </button>
              <button
                className="btn me-2"
                onClick={() => handleBulkDownload(filters)}
                style={{
                  background: "#9CA3AF",
                  color: "white",
                  boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
                }}
              >
                Bulk Download <i className="fa-solid fa-download ms-1"></i>
              </button>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleBulkUpload}
                style={{ display: 'none' }} // Hide the input
                 accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <button onClick={handleButtonClick} style={{
                background: "#9CA3AF",
                color: "white",
                border: "none",
                borderRadius: "3px",
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
              }}>
               Edit Bulk Upload <i className="fa-solid fa-upload ms-1"></i>
              </button>
            </div>
          </div>

          <div className="card shadow">
            <div className="card-body">
              <div style={{ position: 'relative' }}>
              {isLoading && (
                <div className="loader-overlay">
                 <div className="spinner" />
                </div>
              )}
             <div className="table-responsive" style={{ position: 'relative' }}>
              <div className="ag-theme-alpine" style={{ width: '100%' }}>
              <AgGridReact
              ref={gridRef}
              domLayout="autoHeight"
              defaultColDef={defaultColDef}
              columnDefs={columnDefs}
              rowData={isLoading ? [] : filteredData}
              pagination={true}
              quickFilterText={search}
              paginationPageSize={10}
              rowHeight={45}
              overlayNoRowsTemplate={
                !isLoading
                  ? '<span class="ag-overlay-loading-center">No data available</span>'
                  : undefined // ✅ Don't render overlay at all when loading
              }
              onGridReady={(params) => params.api.sizeColumnsToFit()}
            />


              </div>
            </div>

              </div>
            </div>
          </div>
        </div>
      </main>
      <Modal show={addShow} onHide={handleAddClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Add Bulk Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center m-4 ">
            <ReportAdd
              addDetails={addDetails}
              setAddShow={setAddShow}
              fetchData={fetchData}
              handleSearch={handleSearch}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={editShow} onHide={handleEditClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Edit Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center align-items-center m-4 ">
            <ReportEdit
              editableDetails={editdetails}
              setEditShow={setEditShow}
              fetchData={fetchData}
              handleSearch={handleSearch}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
    </>
   
  );
}

export default Reports;
